import { render } from "./SelectAppLanguage.vue?vue&type=template&id=fe20e6b0"
import script from "./SelectAppLanguage.vue?vue&type=script&lang=js"
export * from "./SelectAppLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__